import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

// path 和 name 同名
// 统一使用横线分割单词，例如 /user-list
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: '/',
    component: () => import('@/components/Layout/index.vue'),
    children: [
      {
        path: '',
        name: 'work',
        component: () => import('@/views/Dashboard/index.vue'),
        meta: {
          title: '我的工作站',
          bName: '首页',
          hidden: true,
          indexPath: '1',
          icon: 'icon-a-wodegongzuozhan1'
        }
      },
      {
        path: '/notice',
        name: 'Notice',
        component: () => import('@/views/noticeCenter/index.vue'),
        meta: {
          title: '通知中心',
          bName: '通知中心',
          hidden: true,
          indexPath: '2',
          icon: 'icon-a-wodegongzuozhan1'
        }
      },
      {
        path: 'archive',
        name: 'archive',
        component: () => import('../views/archive/archiveList.vue'),
        meta: {
          title: '归档中心',
          bName: '归档中心',
          indexPath: '2',
          icon: 'icon-a-guanlizhongxin1'
        }
      },
      {
        path: 'upload-file',
        name: 'upload-file',
        component: () => import('../views/archive/uploadFile.vue'),
        meta: {
          title: '上传文档',
          bName: '上传文档',
          hidden: true,
          indexPath: '2',
          parentNav: { path: '/archive', pName: '归档中心' }
        }
      },
      {
        path: 'attestation',
        name: 'attestation',
        component: () => import('../views/staticKnowledge/attestationList.vue'),
        meta: {
          title: '静态知识认证',
          bName: ' 静态知识认证',
          hidden: true,
          indexPath: '3',
          parentNav: { path: '/attestation-center', pName: '认证中心' }
        }
      },
      {
        path: 'attestation-center',
        name: 'attestation-center',
        component: () => import('../views/staticKnowledge/attestationCenter.vue'),
        meta: {
          title: '认证中心',
          bName: '认证中心',
          indexPath: '3',
          icon: 'icon-a-renzhengzhongxin1'
        }
      },
      {
        path: 'quality-center',
        name: 'quality-center',
        component: () => import('../views/qualityCenter/qualityCenterList.vue'),
        meta: {
          title: '质控中心',
          bName: '质控中心',
          indexPath: '4',
          icon: 'icon-a-zhikongzhongxin'
        }
      },
      {
        path: 'quality-add',
        name: 'quality-add',
        component: () => import('../views/qualityCenter/qualityAdd.vue'),
        meta: {
          title: '新增知识',
          bName: '新增知识',
          hidden: true,
          indexPath: '4',
          parentNav: { path: '/quality-center', pName: '质控中心' }
        }
      },
      {
        path: 'quality-edit',
        name: 'quality-edit',
        component: () => import('../views/qualityCenter/qualityAdd.vue'),
        meta: {
          title: '编辑知识',
          bName: '编辑知识',
          hidden: true,
          indexPath: '4',
          parentNav: { path: '/quality-center', pName: '质控中心' }
        }
      },
      {
        path: 'my-pathway',
        name: 'my-pathway',
        component: () => import('../views/clinicalPathway/MyPathway/index.vue'),
        meta: {
          title: '路径中心',
          bName: '路径中心',
          indexPath: '5',
          icon: 'icon-a-jiexizhongxin1'
        }
      },
      {
        path: 'pathway-editing',
        name: 'pathway-editing',
        component: () => import('../views/clinicalPathway/PathwayEditing/index.vue'),
        meta: {
          title: '路径编辑',
          bName: '路径编辑',
          hidden: true,
          indexPath: '5',
          icon: 'icon-a-renzhengzhongxin1',
          parentNav: { path: '/my-pathway', pName: '我的路径' }
        }
      },
      {
        path: 'pathway-preview',
        name: 'pathway-preview',
        component: () => import('../views/clinicalPathway/PathwayEditing/Preview.vue'),
        meta: {
          title: '路径预览',
          bName: '路径预览',
          hidden: true,
          indexPath: '5',
          icon: 'icon-a-renzhengzhongxin1',
          parentNav: { path: '/my-pathway', pName: '我的路径' }
        }
      },
      {
        path: 'publish-center',
        name: 'publish-center',
        component: () => import(/* webpackChunkName: "archiveList" */ '../views/publish/publishCenter.vue'),
        meta: { title: '发布中心', bName: '发布中心', indexPath: '6', icon: 'icon-a-renzhengzhongxin1' }
      },
      {
        path: 'to-publish',
        name: 'to-publish',
        component: () => import(/* webpackChunkName: "archiveList" */ '../views/publish/toPublish.vue'),
        meta: { title: '去发布', bName: ' 去发布', hidden: true, indexPath: '6', parentNav: { path: '/publish-center', pName: '发布中心' } }
      },
      {
        path: 'project-news',
        name: 'project-news',
        component: () => import('../views/projectNews/index.vue'),
        meta: {
          title: '项目动态',
          bName: '项目动态',
          indexPath: '7',
          icon: 'icon-a-renzhengzhongxin1',
          hidden: true,
        }
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login/index.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/shared-pathway-preview',
    name: 'shared-pathway-preview',
    component: () => import('@/views/clinicalPathway/SharedPathwayPreview/SharedPathwayPreview.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
